/* eslint-disable @typescript-eslint/ban-ts-comment */
/*
    ********************************************************************************
        Configuring AppInsight
    ********************************************************************************
*/

import {
  ReactPlugin,
  withAITracking,
} from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createBrowserHistory } from 'history';
import appSettings from '../../appSettings';
import React from 'react';

//@ts-ignore
const browserHistory = createBrowserHistory({ basename: '' });

// Get the domain for Fed Auth so AppInsights knows to exclude it.
const fedAuthDomain = appSettings.OIDC_PROVIDER?.replace('https://', '')
  ?.replace('http://', '')
  ?.replace('/', '');

// Split/Harness endpoints reject AppInsights correlation headers (request-id).
const splitDomains = ['auth.split.io', 'sdk.split.io', 'events.split.io'];

const appInsightsReactPlugin = new ReactPlugin();
const appInsightsInitializer = new ApplicationInsights({
  config: {
    connectionString: appSettings.APPINSIGHTS_CONNECTION_STRING,
    enableAutoRouteTracking: true,
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true,
    correlationHeaderExcludedDomains: [
      ...(fedAuthDomain ? [fedAuthDomain] : []),
      ...splitDomains,
    ],
    extensions: [appInsightsReactPlugin],
    extensionConfig: {
      [appInsightsReactPlugin.identifier]: { history: browserHistory },
    },
  },
});

appInsightsInitializer.loadAppInsights();

export const appInsightsClient = appInsightsInitializer;

export const withAppInsightsTracking = (Component: React.ComponentType) =>
  withAITracking(appInsightsReactPlugin, Component);
